import { createFileRoute, Link } from "@tanstack/react-router";
import useTranslation from "../../hooks/useTranslation";

export const Route = createFileRoute("/app/check_your_email")({
  component: CheckYourEmailPage,
});

function CheckYourEmailPage() {
  const { translate } = useTranslation();

  return (
    <div className="mt-11 relative bg-white-100 md:bg-white px-6 pb-8 pt-10 md:shadow-xl md:ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
      <div className="mx-auto max-w-md flex flex-col items-center justify-center">
        <div className="pt-8 text-center text-xl font-bold leading-7 text-gray-600">
          <p>Check your email.</p>
        </div>
        <div className="font-regular py-1 text-center text-base leading-7 text-gray-600">
          <p>
            If this email address is associated with an account, instructions to
            reset your password will be sent to you. The email may take a minute
            or two to arrive.
          </p>
        </div>
      </div>
      <div className="pt-8 text-xs text-left leading-7">
        <p className="text-gray-900">
          Didn't receive the email? Check your spam folder.
        </p>
        <p>
          <Link to="/app/reeprise" className="text-sky-500 hover:text-sky-600">
            Resend link &rarr;
          </Link>
        </p>
      </div>

      <div className="mt-11 relative bg-white-100 md:bg-white px-6 pb-8 pt-10 md:shadow-xl md:ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
        <button
          type="button"
          className="absolute top-2 right-2 bg-white rounded-md p-2 justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        >
          <span className="sr-only">Close menu</span>

          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="mx-auto max-w-md flex flex-col items-center justify-center">
          <div className="pt-8 text-center text-xl font-bold leading-7 text-gray-600">
            <p>{translate("header_newName")}</p>
          </div>
          <div className="font-regular py-1 text-center text-base leading-7 text-gray-600">
            <p className="mb-5">{translate("subtitle_newName")}</p>
            <ul className="list-disc text-left">
              <li>
                <span className="font-bold">Keep it short and simple:</span> Up
                to 9 characters.
              </li>
              <li>
                <span className="font-bold">No worries:</span> You can change
                the name anytime!
              </li>
            </ul>
            <p className="mt-10">{translate("subtext_newName")}</p>
            <input
              className="w-full p-2 border rounded-sm mt-10 mb-5"
              placeholder={translate("button_newName")}
            />
            <button
              type="submit"
              className="mb-2 w-full bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition duration-200"
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
